import React from "react";
import { proxyAPI } from "../proxyAPI";
import MyModal from "../Common/MyModal";
import Contacts from "../Contacts/Contacts";
import { Link } from "react-router-dom";
import { isUserPermitted } from "../helpers/pageProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faPen, faUser } from "@fortawesome/free-solid-svg-icons";
import FullScreenLoadingIndicator, {
  AbsoluteLoadingIndicator,
} from "../Common/FullScreenLoadingIndicator";

export default function ReportingContactsList({
  label,
  uuid,
  kind,
}: {
  label: string;
  uuid: string;
  kind: "entry" | "ticket";
}) {
  const [contacts, setContacts] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);

  const getContacts = async (page = 0, perPage = 10) => {
    setLoading(true);
    const data = await proxyAPI({
      prefix: "logic/reporting",
      url: `contacts?kind=${kind}&items=${uuid}&pagination.perPage=${perPage}&pagination.page=${page}`,
    });
    setTimeout(() => {
      //   if (data?.data) {
      setContacts(data?.data);
      setLoading(false);
      //   }
    }, 500);
  };

  return (
    <MyModal
      label={
        <div>
          <FontAwesomeIcon icon={faUser} className="me-2" />
          <div className="badge bg-secondary">{label}</div>
        </div>
      }
      buttonClassName="btn-outline-secondary px-1"
      heading="Contacts"
      onShow={getContacts}
      size="lg"
    >
      <div style={{ minHeight: "400px" }}>
        {loading ? null : //   <AbsoluteLoadingIndicator loading={loading} />
        !!contacts?.length ? (
          <Contacts
            filters={[]}
            fields={undefined}
            useSearchOptions={true}
            includeContacts={contacts}
            ignoreContacts={undefined}
            ignoreSets={undefined}
            contactSet={undefined}
            contactSets={[]}
            strictCriteria={undefined}
            doNotUseSets={undefined}
            notDraggable={undefined}
            onDrop={undefined}
            allContactsButton={undefined}
            isModal={undefined}
            showContactFields={undefined}
            setSelectedContacts={undefined}
            contactButton={(c: any) => (
              <Link
                to={`/assets/contacts/edit/${c.uuid}`}
                title={
                  isUserPermitted("edit_contact")
                    ? "View / Edit contact"
                    : "View contact"
                }
              >
                <FontAwesomeIcon
                  icon={
                    isUserPermitted("edit_contact") ? faPen : faMagnifyingGlass
                  }
                />
              </Link>
            )}
          />
        ) : (
          "No contacts found"
        )}
      </div>
    </MyModal>
  );
}
